class TelemetryProvider {
  info(title = "", properties = {}) {
    throw new Error("info() must be implemented in child class");
  }

  error(title = "", properties = {}) {
    throw new Error("error() must be implemented in child class");
  }
}

export default TelemetryProvider;



// WEBPACK FOOTER //
// ./client/src/telemetry/telemetryProvider.js